/// <reference path="../../components/common/notificationSetting.service.ts" />
/// <reference path="../../components/commonClasses/commonControllerBase.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="meevoBi.module.ts" />

module Meevo.Plugins.MeevoBi {

    class MeevoBiController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$http"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected businessInfoDataService: Meevo.Components.Common.HolidayDataService,
            protected identityDataService: Meevo.Components.Common.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: any,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $http: angular.IHttpService) {

            super(appSettings, businessInfoDataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.INTEGRATION_MEEVOBI).then(() => {
                vm.busyService.stop();
                vm.context = new MeevoBiContext(vm.appSettings, vm.businessInfoDataService, vm.identityDataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$http);
                super.createContext();
            });
        }

    }

    angular.module("meevo.plugins.meevoBi")
        .controller("meevo.plugins.meevoBi.meevoBiController", MeevoBiController);
}